import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  adornment: {
    alignSelf: 'flex-start',
    marginTop: theme.spacing(1),
  },
}))

export default styles
